<template>
  <div class="comment">
    <div v-for="(item,index) in chartList" :key="index" class="com_box">

      <div v-if="item.baseId!=baseId" class="com_right_box">

        <div class="logo">
          <img src="@/assets/logo.png" width="100%" height="100%" alt="">
        </div>

        <span class="mseeageBox">
          <span class="name">溺水三千</span>
          <span class="content com_left">
            <div class="triangle tr_left"></div>
            <span>
              {{item.content}}
            </span>
            <span v-if="item.img" class="img">
              <img :src="item.img" width="100%" alt="">
            </span>
          </span>
        </span>

      </div>

      <div v-if="item.baseId==baseId" class="com_right_box">
        <span style="flex:1"></span>

        <span class="mseeageBox">
          <span class="name tr"></span>
          <span class="content com_right">
            <div class="triangle tr_right"></div>
            <span>
              {{item.content}}
            </span>
            <span v-if="item.img" class="img">
              <img :src="item.img" width="100%" alt="">
            </span>
          </span>
        </span>

        <div class="logo2">
          <img src="@/assets/logo.png" width="100%" height="100%" alt="">
        </div>
      </div>

    </div>

    <div class="inpBox">
      <div>
        <a-button class="imgUp" shape="circle">
          <span class="iconfont icon-tupian1"> </span>
          <div class="img_up">
            <upload :width='"32px"' :height='"32px"' @uploadOk='uploadOk'></upload>
          </div>
        </a-button>
      </div>
      <div class="inp">
        <a-input v-model="inp" placeholder="" />
      </div>
      <div>
        <a-button @click="sendMsg()" type="primary">发送</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import upload from '@/components/upload.vue';
import $ from 'jquery'
export default {
  components: {
    upload
  },
  data() {
    return {
      baseId: 1,
      inp: '',
      chartList: [{
        baseId: 1,
        "id": "4",
        "name": "",
        "content": "英文频道",
        "living_id": "237",
        "is_deleted": "0",
        "create_time": "2023/06/16 16:04"
      },
      {
        baseId: 1,
        img: require('@/assets/002 (1).jpg'),
        "id": "3",
        "name": "",
        "content": "国内老师讲哪里听自己讲解的声音啊？而不是传译的声音",
        "living_id": "237",
        "is_deleted": "0",
        "create_time": "2023/06/16 15:36"
      },
      {
        baseId: 2,
        img: '',
        "id": "2",
        "name": "",
        "content": "期待",
        "living_id": "237",
        "is_deleted": "0",
        "create_time": "2023/06/09 16:45"
      }, {
        baseId: 1,
        "id": "1",
        "name": "",
        "content": "英文频道",
        "living_id": "237",
        "is_deleted": "0",
        "create_time": "2023/06/16 16:04"
      }, {
        baseId: 2,
        img: '',
        "id": "12",
        "name": "",
        "content": "期待",
        "living_id": "237",
        "is_deleted": "0",
        "create_time": "2023/06/09 16:45"
      }, {
        baseId: 2,
        img: '',
        "id": "122",
        "name": "",
        "content": "期待",
        "living_id": "237",
        "is_deleted": "0",
        "create_time": "2023/06/09 16:45"
      },
      ]
    }
  }, 
  methods: {
    uploadOk(data) {
      console.log(data)
      this.chartList.push({
        baseId: 1,
        "name": "",
        img: data.payload.path,
        "content": '',
        "living_id": this.$route.query.id,
        "create_time": new Date().toLocaleString()
      })

    },
    sendMsg() {
      this.chartList.push({
        baseId: 1,
        "name": "",
        "content": this.inp,
        "living_id": this.$route.query.id,
        "create_time": new Date().toLocaleString()
      })

      let _this = this
      setTimeout(function () {
        _this.chartList.push({
          baseId: 2,
          "name": "",
          "content": _this.inp,
          "living_id": _this.$route.query.id,
          "create_time": new Date().toLocaleString()
        })

        _this.inp = ''

      }, 2000)



    }
  }
}
</script>

<style lang="less" scoped>
.com_box {
  background-color: #f5f5f5;
  padding: 20px;
}
.mseeageBox {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  max-width: 50%;
}
.name {
  font-size: 14px;
  margin-bottom: 10px;
}
.tr {
  text-align: right;
}
.content {
  position: relative;
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
  padding: 10px;
  border-radius: 4px;
}
.com_left {
  background-color: #fff;
}
.com_right {
  background-color: #89d961;
}
.com_right_box {
  display: flex;
  position: relative;
}
.logo {
  width: 44px;
  height: 54px;
  margin-right: 15px;
  padding-top: 10px;
}
.logo2 {
  width: 44px;
  height: 54px;
  padding-top: 10px;
  margin-left: 15px;
}
.triangle {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 10px solid skyblue;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-radius: 4px;
}
.tr_left {
  left: -7px;
  transform: rotate(180deg);
  border-left: 10px solid white;
}
.tr_right {
  right: -7px;
  border-left: 10px solid #89d961;
}
.inpBox {
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 768px;
  display: flex;
  background-color: #fff;
  padding: 5px;
}
.inp {
  flex: 1;
  margin: 0 10px;
}
.img { 
  display: inline-block;
}
.imgUp {
  position: relative;
  overflow: hidden;
}
.img_up {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 44px;
  height: 44px;
  opacity: 0;
}
</style>